var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrivate = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 6.17L5.49014 1.66C7.07014 0.61 8.96014 0 11.0001 0C16.5201 0 21.0001 4.48 21.0001 10C21.0001 12.04 20.3901 13.93 19.3401 15.51L17.8801 14.05C18.5901 12.87 19.0001 11.48 19.0001 10C19.0001 6.65 16.9301 3.78 14.0001 2.59V3C14.0001 4.1 13.1001 5 12.0001 5H10.0001V6.17ZM20.1901 19.19L18.7801 20.6L16.5101 18.33C14.9301 19.39 13.0401 20 11.0001 20C5.48014 20 1.00014 15.52 1.00014 10C1.00014 7.96 1.61014 6.07 2.66014 4.49L0.390137 2.22L1.80014 0.81L20.1901 19.19ZM10.0001 16C8.90014 16 8.00014 15.1 8.00014 14V13L3.21014 8.21C3.08014 8.79 3.00014 9.38 3.00014 10C3.00014 14.08 6.05014 17.44 10.0001 17.93V16Z",
    fill: "#0E1F3C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrivate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Private.7f02f676ff38d67f759e2756206fd2be.svg";